import { render, staticRenderFns } from "./BCXMessengerTools.vue?vue&type=template&id=8634335e&scoped=true"
import script from "./BCXMessengerTools.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerTools.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerTools.vue?vue&type=style&index=0&id=8634335e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8634335e",
  null
  
)

export default component.exports